import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { history } from '../data/mock';
import { Card } from './ui/card';
import { Clock } from 'lucide-react';

const History = () => {
  const { t, language } = useLanguage();
  const historyData = history[language];

  return (
    <section id="history" className="py-24 bg-stone-950">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 text-emerald-400 mb-4">
            <Clock className="w-5 h-5" />
            <span className="text-sm font-semibold tracking-wider uppercase">
              {t.history.title}
            </span>
          </div>
          <h2 className="text-4xl sm:text-5xl font-bold text-white">
            {t.history.title}
          </h2>
        </div>

        {/* Timeline */}
        <div className="relative">
          {/* Timeline Line */}
          <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-0.5 bg-gradient-to-b from-emerald-500 via-emerald-600 to-emerald-800" />

          {/* Timeline Items */}
          <div className="space-y-12">
            {historyData.map((item, index) => (
              <div
                key={item.year}
                className={`relative flex items-center ${
                  index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
                }`}
              >
                {/* Timeline Dot */}
                <div className="absolute left-4 md:left-1/2 w-4 h-4 -translate-x-1/2 bg-emerald-500 rounded-full border-4 border-stone-950 z-10" />

                {/* Content */}
                <div className={`w-full md:w-1/2 ${index % 2 === 0 ? 'md:pr-12 pl-12 md:pl-0' : 'md:pl-12 pl-12'}`}>
                  <Card className="bg-stone-900/50 border-stone-800 p-6 hover:bg-stone-900 transition-all duration-300 hover:border-emerald-600/30 group">
                    <div className="flex items-center gap-4 mb-3">
                      <span className="text-3xl font-bold text-emerald-400 group-hover:text-emerald-300 transition-colors">
                        {item.year}
                      </span>
                    </div>
                    <h3 className="text-xl font-semibold text-white mb-2">
                      {item.title}
                    </h3>
                    <p className="text-stone-400 leading-relaxed">
                      {item.description}
                    </p>
                  </Card>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default History;
